import React from 'react';
import { LoadingOverlay } from 'react-design-components';

interface Props {
  loading?: boolean;
}

const Loading = ({ loading }: Props) => <LoadingOverlay visible={loading} />;

Loading.defaultProps = {
  loading: true,
};

export default Loading;
